import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

function currentIntlLocale(): string {
  if (typeof window === "undefined") return "en-US";
  const locale = window.localStorage.getItem("attenda.locale") ?? document.documentElement.lang;
  return locale.toLowerCase().startsWith("zh") ? "zh-CN" : "en-US";
}

export function formatDateTime(value: string): string {
  return new Intl.DateTimeFormat(currentIntlLocale(), {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));
}
